import { NavigationPath, NavPoiPath } from "@/types/navigation";

const BASE = process.env.REACT_APP_BACKEND_URL || "";
const API_ROUTE_ENDPOINT = "/navigation";


type RouteData = {
  data: NavPoiPath;
  navAnswer: string;
}

type SavedRoute = {
  success: boolean
  token: string
}

export async function getRoute(token: string) {
  const url = `${BASE}${API_ROUTE_ENDPOINT}/${token}`
  console.log("url", url)
  const res = await fetch(url, {
    method: "GET",
    headers: { "Content-Type": "application/json" }
  });

  if (!res.ok) throw new Error(`Failed: ${res.status}`);

  const data = (await res.json()) as RouteData;
  return data;
}


export async function saveRoute(nav: any, navAnswer: any) {
  const url = `${BASE}${API_ROUTE_ENDPOINT}/save`
  const res = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ nav: nav, navAnswer: navAnswer })
  });

  if (!res.ok) throw new Error(`Failed: ${res.status}`);

  const data = (await res.json()) as SavedRoute;
  return data.token;
}
